import React from 'react';
// Game(kit) imports
import gameKit from '../../../GameKit';
import settings from '../../../settings';
// Gameplayer imports
import store from '../../../GamePlayerUI/store';
import { setFullscreen } from '../../../GamePlayerUI/actions/gameInfoActions';

class ButtonsContainer extends React.Component {
    componentDidUpdate() {
        gameKit.game.updateRenderSize();
    }

    onStart = () => {
        gameKit.levelEditor.startTest();
    };

    onStop = () => {
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
        store.dispatch(setFullscreen(false));
        gameKit.levelEditor.stopTest();
    };

    onSnapshot = e => {
        e.preventDefault();
        window.document.activeElement.blur();
        gameKit.makeScreenshot();
    };

    TestButton = () => {
        const { isTesting } = this.props;

        const containerClassName = 'btn-test-container';
        const btnClassName = 'btn-test';

        if (isTesting) {
            return (
                <div className={containerClassName}>
                    <button id="btn-stop-test" type="button" onClick={this.onStop} className={btnClassName}>
                        stop
                    </button>
                </div>
            );
        }
        return (
            <div className={containerClassName}>
                <button id="btn-start-test" type="button" onClick={this.onStart} className={btnClassName}>
                    test
                </button>
            </div>
        );
    };

    CameraButton = () => {
        const { isTesting } = this.props;

        const className = 'padding';

        if (isTesting) {
            return (
                <div className={`${className} camera-container`}>
                    <button id="btn-snapshot" type="button" onClick={this.onSnapshot}>
                        <img src={`${settings.assetsPath}img/icons/camera.png`} alt="Screenshot" />
                    </button>
                </div>
            );
        }
        return <div className={className} />;
    };

    getContainerClassName = () => {
        const { isTesting } = this.props;

        if (isTesting) {
            return 'is-absolute';
        }
        return '';
    };

    render() {
        return (
            <div id="test-player-buttons-container" className={this.getContainerClassName()}>
                <div className="padding" />
                <this.TestButton />
                <this.CameraButton />
            </div>
        );
    }
}

ButtonsContainer.defaultProps = {
    isTesting: false
};

export default ButtonsContainer;
